!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("@uauth/common"), require("@uauth/dom-ui"), require("@unstoppabledomains/resolution"), require("global"), require("jose-jwe-jws")) : "function" == typeof define && define.amd ? define(["@uauth/common", "@uauth/dom-ui", "@unstoppabledomains/resolution", "global", "jose-jwe-jws"], t) : (e || self).UAuth = t(e.common, e.DomUI, e.Resolution, e.global, e.joseJweJws);
}(this, function (e, t, r, n, o) {
  function i(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  var u = /*#__PURE__*/i(t),
    s = /*#__PURE__*/i(r),
    c = /*#__PURE__*/i(n);
  function a() {
    return a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }
      return e;
    }, a.apply(this, arguments);
  }
  function l(e, t) {
    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, h(e, t);
  }
  function f(e) {
    return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, f(e);
  }
  function h(e, t) {
    return h = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, h(e, t);
  }
  function d() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function p(e, t, r) {
    return p = d() ? Reflect.construct : function (e, t, r) {
      var n = [null];
      n.push.apply(n, t);
      var o = new (Function.bind.apply(e, n))();
      return r && h(o, r.prototype), o;
    }, p.apply(null, arguments);
  }
  function m(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return m = function m(e) {
      if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }
      function r() {
        return p(e, arguments, f(this).constructor);
      }
      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), h(r, e);
    }, m(e);
  }
  function v(e, t) {
    if (null == e) return {};
    var r,
      n,
      o = {},
      i = Object.keys(e);
    for (n = 0; n < i.length; n++) {
      t.indexOf(r = i[n]) >= 0 || (o[r] = e[r]);
    }
    return o;
  }
  function g(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }
    return n;
  }
  function w(e, t) {
    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (r) return (r = r.call(e)).next.bind(r);
    if (Array.isArray(e) || (r = function (e, t) {
      if (e) {
        if ("string" == typeof e) return g(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? g(e, t) : void 0;
      }
    }(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var n = 0;
      return function () {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _(e, t) {
    /*#__PURE__*/return function (r) {
      function n() {
        var n;
        return (n = r.call(this, t) || this).name = e, n;
      }
      return l(n, r), n;
    }( /*#__PURE__*/m(Error));
  }
  var y = _("PopupTimeoutError", "The popup has timed out."),
    P = _("PopupClosedError", "The popup was closed."),
    b = function b(e) {
      return String.fromCharCode.apply(null, Array.from(new Uint8Array(e)));
    },
    R = new TextEncoder(),
    O = function O() {
      return c.default;
    },
    S = function S(e) {
      return O().btoa(e);
    },
    k = function k(e) {
      return S(e).replace(/=+$/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    A = function A() {
      var e;
      return null != (e = O().crypto) ? e : O().msCrypto;
    },
    j = function j(e) {
      return A().getRandomValues(new Uint8Array(e));
    },
    T = function T() {
      var e;
      return null != (e = A().subtle) ? e : A().webkitSubtle;
    },
    U = function U(e) {
      try {
        var t = T().digest({
          name: "SHA-256"
        }, e);
        return O().msCrypto ? Promise.resolve(new Promise(function (e, r) {
          t.oncomplete = function (t) {
            return e(t.target.result);
          }, t.onerror = function (e) {
            return r(e.error);
          }, t.onabort = function () {
            return r("The digest operation was aborted");
          };
        })) : Promise.resolve(t);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    z = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.",
    I = function I(e) {
      return O().atob(e);
    },
    L = new TextDecoder();
  function E(e) {
    return Array.from(new Set(e));
  }
  var C = function C(e) {
    return E(e.trim().split(/\s+/)).sort().join(" ");
  };
  function q(e) {
    var t = {};
    return e.forEach(function (r, n) {
      t[n] = e.getAll(n).length > 1 ? e.getAll(n) : e.get(n);
    }), t;
  }
  function D(e) {
    var t = new URLSearchParams([].concat(Object.entries(e)).filter(function (e) {
      return null != e[0] && null != e[1];
    }));
    return t.sort(), t.toString();
  }
  var x = {
      createCodeChallengeAndVerifier: function createCodeChallengeAndVerifier(e, t) {
        void 0 === e && (e = 43), void 0 === t && (t = "S256");
        try {
          var r = function (e) {
            return Array.from(j(e)).map(function (e) {
              return z[e % z.length];
            }).join("");
          }(e);
          switch (t) {
            case "plain":
              return Promise.resolve({
                verifier: r,
                challenge: r
              });
            case "S256":
              return Promise.resolve(U(R.encode(r).buffer)).then(function (e) {
                return {
                  verifier: r,
                  challenge: k(b(e))
                };
              });
            default:
              throw new Error("bad challenge method");
          }
        } catch (e) {
          return Promise.reject(e);
        }
      },
      createRemoteJWKGetter: function createRemoteJWKGetter(e) {
        return function (t) {
          try {
            return Promise.resolve(fetch(e).then(function (e) {
              return e.json();
            })).then(function (e) {
              var r = e.keys.find(function (e) {
                return e.kid === t;
              });
              if (r) return o.Jose.Utils.importPublicKey(r, "RS256");
              throw new Error("Unable to find a signing key that matches '" + t + "'");
            });
          } catch (e) {
            return Promise.reject(e);
          }
        };
      },
      getCrypto: A,
      getCryptoSubtle: T,
      getRandomBytes: j,
      sha256: U,
      verifyIdToken: function verifyIdToken(e, t, r) {
        try {
          return Promise.resolve(new o.Jose.JoseJWS.Verifier(new o.Jose.WebCryptographer(), t, e).verify()).then(function (e) {
            var n = e[0];
            if (!n.verified) throw new Error("Failed to verify id_token!");
            var o = JSON.parse(n.payload);
            if (o.__raw = t, r !== o.nonce) throw new Error("nonces don't match");
            return o;
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    F = {
      decodeState: function decodeState(e) {
        var t = e.split("."),
          r = t[1];
        if (t.slice(2).length > 0) throw new Error("failed to decode state");
        return (null == r ? void 0 : r.length) > 0 ? JSON.parse(decodeURIComponent(I(r))) : void 0;
      },
      encodeState: function encodeState(e) {
        return k(b(j(32))) + "." + (null == e ? "" : k(encodeURIComponent(JSON.stringify(e))));
      },
      fromBase64: I,
      textDecoder: L,
      textEncoder: R,
      toBase64: S,
      toUrlEncodedBase64: k,
      stringFromBuffer: b
    },
    J = {
      __proto__: null,
      crypto: x,
      encoding: F,
      getSortedScope: C,
      getWindow: O,
      objectFromEntries: function objectFromEntries(e) {
        for (var t, r = {}, n = w(e); !(t = n()).done;) {
          var o = t.value;
          r[o[0]] = o[1];
        }
        return r;
      },
      objectFromURLSearchParams: q,
      objectToKey: D,
      retry: function e(t, r, n, o, i) {
        return void 0 === r && (r = 4), void 0 === n && (n = 250), void 0 === o && (o = 2), void 0 === i && (i = null), r <= 0 ? Promise.reject(i) : t().catch(function (i) {
          try {
            return Promise.resolve(new Promise(function (e) {
              return setTimeout(e, n);
            })).then(function () {
              return e(t, r - 1, n * o, o, i);
            });
          } catch (e) {
            return Promise.reject(e);
          }
        });
      },
      uniqueElementsFromArray: E
    },
    W = /*#__PURE__*/function (e) {
      function t(t, r, n) {
        var o;
        return (o = e.call(this, t + ": " + r + (n ? "\nSee more at " + n + "." : "")) || this).code = void 0, o.description = void 0, o.uri = void 0, o.code = t, o.description = r, o.uri = n, o;
      }
      return l(t, e), t.fromResponse = function (e) {
        return new t(e.error, e.error_description, e.error_uri);
      }, t;
    }( /*#__PURE__*/m(Error)),
    B = ["url"],
    M = ["url", "client_id", "client_secret", "client_auth_method"],
    N = /*#__PURE__*/function () {
      function e(e) {
        this.options = void 0, this.options = e;
      }
      var t = e.prototype;
      return t.buildAuthorizeUrl = function (e) {
        return this._buildUrl(e);
      }, t.buildLogoutUrl = function (e) {
        return this._buildUrl(e);
      }, t.parseAuthorizeResponseFromFragment = function (e) {
        return this._validateResponse(q(new URLSearchParams(new URL(e).hash.substring(1))));
      }, t.parseAuthorizeResponseFromQuery = function (e) {
        return this._validateResponse(q(new URL(e).searchParams));
      }, t.authorizeWithPopup = function (e, t) {
        void 0 === t && (t = {});
        try {
          var r,
            n = this;
          if (!n.options.window) throw new Error("no window in options");
          var o = n.buildAuthorizeUrl(e),
            i = t.popup,
            u = null != (r = t.timeout) ? r : 3e5;
          if (i) i.location.href = o;else if (!(i = n.options.window.open(o, "uauth:authorize:popup", "left=" + (n.options.window.screenX + (n.options.window.innerWidth - 400) / 2) + ",top=" + (n.options.window.screenY + (n.options.window.innerHeight - 600) / 2) + ",width=400,height=600,resizable,scrollbars=yes,status=1"))) throw new Error("popup failed to be constructed");
          var s = !1;
          return Promise.resolve(new Promise(function (t, r) {
            var o = setTimeout(function () {
                s || (clearInterval(c), i.close(), r(new y()));
              }, u),
              c = setInterval(function () {
                var u, a, l, f;
                !s && null != (u = i) && u.closed && (clearInterval(c), clearTimeout(o), r(new P()));
                try {
                  a = i.location.href, l = new URL(a), f = new URL(e.redirect_uri);
                } catch (e) {
                  return;
                }
                if (l.hash = "", l.href === f.href) {
                  s = !0, clearInterval(c), clearTimeout(o), i.close();
                  try {
                    t(n.parseAuthorizeResponseFromFragment(a));
                  } catch (e) {
                    r(e);
                  }
                }
              }, 10);
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.authorizeWithDevice = function (e) {
        return Promise.resolve({});
      }, t.getToken = function (e) {
        try {
          var t = this._buildRequest(e, {
            method: "POST"
          });
          return Promise.resolve(this._fetchJSON(t[0], t[1]));
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.introspect = function (e) {
        var t = this._buildRequest(e, {
          method: "POST"
        });
        return this._fetchJSON(t[0], t[1]);
      }, t.revoke = function (e) {
        try {
          var t = this._buildRequest(e, {
            method: "POST"
          });
          return Promise.resolve(this._fetchJSON(t[0], t[1])).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.userinfo = function (e) {
        var t = this._buildRequest(e, {
          method: "GET",
          headers: {
            Authorization: "Basic " + e.access_token
          }
        });
        return this._fetchJSON(t[0], t[1]);
      }, t.jwks = function (e) {
        var t = this._buildRequest(e, {
          method: "GET"
        });
        return this._fetchJSON(t[0], t[1]);
      }, t.getTokenWithAuthorizationCode = function (e) {
        return this.getToken(e);
      }, t.getTokenWithRefreshToken = function (e) {
        return this.getToken(e);
      }, t.getTokenWithDeviceCode = function (e) {
        return this.getToken(e);
      }, t.getTokenWithPassword = function (e) {
        return this.getToken(e);
      }, t.getTokenWithSAML = function (e) {
        return this.getToken(e);
      }, t.getTokenWithClientCredentials = function (e) {
        return this.getToken(e);
      }, t._buildUrl = function (e) {
        for (var t = e.url, r = v(e, B), n = new URL(t), o = new URLSearchParams(), i = 0, u = Object.entries(r); i < u.length; i++) {
          var s = u[i],
            c = s[0],
            a = s[1];
          null != c && null != a && o.append(c, a);
        }
        return n.search = o.toString(), n.toString();
      }, t._buildRequest = function (e, t) {
        var r,
          n = e.url,
          o = e.client_id,
          i = e.client_secret,
          u = e.client_auth_method,
          s = v(e, M),
          c = t.headers,
          l = t.method,
          f = new Headers(null != (r = this.options.headers) ? r : []);
        new Headers(null != c ? c : []).forEach(function (e, t) {
          f.set(t, e);
        }), "POST" === t.method && f.set("Content-Type", "application/x-www-form-urlencoded");
        var h = a({
          client_id: o
        }, s);
        switch (u) {
          case "client_secret_basic":
            if (null == i) throw new Error("Client secret not present!");
            f.set("Authorization", "Basic " + S(o + ":" + i));
            break;
          case "client_secret_post":
            if (null == i) throw new Error("Client secret not present!");
            h.client_secret = i;
            break;
          case "none":
          case void 0:
          case null:
            break;
          default:
            throw new Error("Bad client_auth_method");
        }
        return [n, {
          method: l,
          headers: f,
          body: "POST" === l ? new URLSearchParams(Object.entries(h)) : void 0
        }];
      }, t._validateResponse = function (t) {
        if (t.error) throw e.Error.fromResponse(t);
        return t;
      }, t._fetchJSON = function (e, t) {
        try {
          var r,
            n = this;
          if (t.headers) {
            var o = new Headers(t.headers);
            o.set("Accept", "application/json"), t.headers = o;
          } else t.headers = {
            Accept: "application/json"
          };
          if (!n.options.window) throw new Error("no window in options");
          return Promise.resolve(null == (r = n.options.window) ? void 0 : r.fetch(e, t)).then(function (e) {
            return Promise.resolve(e.json()).then(function (t) {
              if (n._validateResponse(t), !e.ok) throw new Error(e.status + " " + e.statusText + ": " + JSON.stringify(t));
              return t;
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, e;
    }();
  N.Error = W;
  var V = /*#__PURE__*/function () {
      function e(e) {
        this.client = void 0, this.client = e;
      }
      var t = e.prototype;
      return t.get = function (e, t) {
        var r = void 0 === t ? {} : t,
          n = r.mustExist,
          o = void 0 !== n && n,
          i = r.deleteAfter,
          u = void 0 !== i && i;
        try {
          var s = this;
          return Promise.resolve(s.client.store.get(e)).then(function (t) {
            var r;
            function n(t) {
              if (r) return t;
              var n = function () {
                if (u) return Promise.resolve(s.client.store.delete(e)).then(function () {});
              }();
              return n && n.then ? n.then(function () {
                return i;
              }) : i;
            }
            if (null != t) {
              var i = t.value,
                c = t.expiresAt,
                a = function () {
                  if (0 !== c && c < Date.now()) return Promise.resolve(s.client.store.delete(e)).then(function () {
                    if (o) throw new Error(e + " does not exist in store");
                    r = 1;
                  });
                }();
              return a && a.then ? a.then(n) : n(a);
            }
            if (o) throw new Error(e + " does not exist in store");
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.set = function (e, t, r) {
        void 0 === r && (r = 0);
        try {
          return Promise.resolve(this.client.store.set(e, {
            expiresAt: 0 === r ? 0 : Date.now() + r,
            value: t
          })).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.setAuthorizeRequest = function (e) {
        try {
          return Promise.resolve(this.set("request", e, 3e5)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.getAuthorizeRequest = function () {
        return this.get("request", {
          mustExist: !0,
          deleteAfter: !0
        });
      }, t.setLogoutRequest = function (e) {
        try {
          return Promise.resolve(this.set("logout-request", e, 3e5)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.getLogoutRequest = function () {
        return this.get("logout-request", {
          mustExist: !0,
          deleteAfter: !0
        });
      }, t.setVerifier = function (e, t) {
        try {
          return Promise.resolve(this.set("verifier:" + e, t, 3e5)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.getVerifier = function (e) {
        return this.get("verifier:" + e, {
          mustExist: !0,
          deleteAfter: !0
        });
      }, t.setOpenIdConfiguration = function (e, t, r) {
        try {
          return Promise.resolve(this.set("openidConfiguration:" + e, t, r)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.getOpenIdConfiguration = function (e) {
        return this.get("openidConfiguration:" + e);
      }, t.setAuthorization = function (e) {
        try {
          var t = this,
            r = function r() {
              return Promise.resolve(t.set("username", n.username, o)).then(function () {
                var r = t.set;
                return Promise.resolve(t._getAuthorizationKey(n)).then(function (n) {
                  return Promise.resolve(r.call(t, n, e, o)).then(function () {});
                });
              });
            },
            n = {
              clientID: e.idToken.aud,
              resource: e.resource,
              scope: e.scope,
              username: e.idToken.sub
            },
            o = e.expiresAt - Date.now(),
            i = function () {
              if (t.client.cacheOptions.setDefaultUsername) return Promise.resolve(t.client.cacheOptions.setDefaultUsername(e.idToken.sub)).then(function () {});
            }();
          return Promise.resolve(i && i.then ? i.then(r) : r());
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.deleteAuthorization = function (e) {
        try {
          var t = this;
          return Promise.resolve(t.get("username")).then(function (r) {
            return Promise.resolve(t._getUsername(e.username, r)).then(function (n) {
              function o() {
                var r = t.client.store,
                  n = r.delete;
                return Promise.resolve(t._getAuthorizationKey(e)).then(function (e) {
                  return n.call(r, e);
                });
              }
              e.username = n;
              var i = function () {
                if (e.username === r) return Promise.resolve(t.client.store.delete("username")).then(function () {});
              }();
              return i && i.then ? i.then(o) : o();
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, t.getAuthorization = function (e) {
        try {
          var t = this,
            r = t.get;
          return Promise.resolve(t._getAuthorizationKey(e)).then(function (e) {
            return r.call(t, e, {
              mustExist: !0
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, t._getAuthorizationKey = function (e) {
        try {
          var t = this,
            r = D,
            n = t._getUsername,
            o = e.username;
          return Promise.resolve(t.get("username")).then(function (i) {
            return Promise.resolve(n.call(t, o, i)).then(function (n) {
              var o, i, u;
              return "authorization?" + r.call(J, {
                username: n,
                clientID: null != (o = e.clientID) ? o : t.client.fallbackLoginOptions.clientID,
                scope: C(null != (i = e.scope) ? i : t.client.fallbackLoginOptions.scope),
                resource: null != (u = e.resource) ? u : t.client.fallbackLoginOptions.resource
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, t._getUsername = function (e, t) {
        try {
          if (null == e && null == t) throw new Error("no username given");
          return Promise.resolve(null != e ? e : t);
        } catch (e) {
          return Promise.reject(e);
        }
      }, e;
    }(),
    K = /*#__PURE__*/function () {
      function e(e) {
        this.storage = void 0, this.storage = e;
      }
      var t = e.prototype;
      return t.get = function (e) {
        var t = this.storage.getItem(e);
        return null != t ? JSON.parse(t) : null;
      }, t.delete = function (e) {
        return this.storage.removeItem(e), !0;
      }, t.set = function (e, t) {
        return this.storage.setItem(e, JSON.stringify(t)), this;
      }, e;
    }(),
    H = ["clientID", "username", "scope", "resource"],
    G = /*#__PURE__*/function () {
      function t(t) {
        var n,
          o,
          i,
          c,
          l,
          f,
          h,
          d,
          p,
          m,
          v,
          g,
          w,
          _ = this;
        if (this.util = J, this.store = void 0, this._clientStore = new V(this), this.api = void 0, this.fallbackIssuer = void 0, this.fallbackLoginOptions = void 0, this.fallbackLogoutOptions = void 0, this.cacheOptions = void 0, this.window = void 0, this.issuerResolver = void 0, this.resolution = void 0, this.ui = void 0, this.window = null != (n = t.window) ? n : window, this.fallbackIssuer = null != (o = t.fallbackIssuer) ? o : "https://auth.unstoppabledomains.com", this.resolution = null != (i = t.resolution) ? i : new s.default(), this.ui = t.ui ? t.ui : t.uiOptions ? new u.default(t.uiOptions) : new u.default(), t.store) this.store = t.store;else switch (null != (w = t.storeType) ? w : "localstore") {
          case "localstore":
            this.store = new K(this.window.localStorage);
            break;
          case "sessionstore":
            this.store = new K(this.window.sessionStorage);
            break;
          case "memory":
            this.store = new Map();
            break;
          default:
            throw new Error("Bad storeType provided");
        }
        this.cacheOptions = a({
          issuer: !1,
          userinfo: !0,
          getDefaultUsername: function getDefaultUsername() {
            var e;
            return null != (e = _.window.localStorage.getItem("uauth-default-username")) ? e : "";
          }
        }, null != (c = t.cacheOptions) ? c : {}), null != (l = t.cacheOptions) && l.getDefaultUsername || null != (f = t.cacheOptions) && f.setDefaultUsername || (this.cacheOptions.setDefaultUsername = function (e) {
          _.window.localStorage.setItem("uauth-default-username", e);
        }), this.api = new N({
          headers: {},
          window: this.window
        }), this.fallbackLoginOptions = {
          clientID: t.clientID,
          clientSecret: t.clientSecret,
          clientAuthMethod: null != (h = t.clientAuthMethod) ? h : t.clientSecret ? "client_secret_post" : "none",
          maxAge: null != (d = t.maxAge) ? d : 3e5,
          prompt: null != (p = t.prompt) ? p : "login",
          resource: t.resource,
          redirectUri: t.redirectUri,
          responseMode: null != (m = t.responseMode) ? m : "fragment",
          scope: null != (v = t.scope) ? v : "openid wallet"
        }, this.fallbackLogoutOptions = {
          rpInitiatedLogout: null != (g = t.rpInitiatedLogout) ? g : "string" == typeof t.postLogoutRedirectUri,
          postLogoutRedirectUri: t.postLogoutRedirectUri
        };
        var y = this;
        this.issuerResolver = new e.DefaultIssuerResolver({
          webfingerResolver: new e.DefaultWebFingerResolver({
            ipfsResolver: new e.DefaultIPFSResolver(function () {
              return (t.createIpfsUrl || e.DefaultIPFSResolver.defaultCreateUrl).apply(void 0, [].slice.call(arguments));
            }),
            domainResolver: {
              records: function records(e, t) {
                try {
                  return Promise.resolve(function (r, n) {
                    try {
                      var o = Promise.resolve(y.resolution.records(e, t));
                    } catch (e) {
                      return n(e);
                    }
                    return o && o.then ? o.then(void 0, n) : o;
                  }(0, function (e) {
                    if (e instanceof r.ResolutionError && e.code === r.ResolutionErrorCode.UnspecifiedResolver) return {};
                    throw e;
                  }));
                } catch (e) {
                  return Promise.reject(e);
                }
              }
            }
          })
        });
      }
      var n = t.prototype;
      return n._createAuthorizeRequestBuilder = function (e) {
        var t = this,
          r = a({}, this.fallbackLoginOptions, e);
        return function (e) {
          try {
            return Promise.resolve(new Promise(function (e) {
              return setTimeout(e, 2e3);
            })).then(function () {
              return Promise.resolve(t.getOpenIdConfiguration(e)).then(function (n) {
                return Promise.resolve(x.createCodeChallengeAndVerifier(43, "S256")).then(function (o) {
                  var i = o.verifier,
                    u = o.challenge,
                    s = F.toBase64(F.stringFromBuffer(x.getRandomBytes(32))),
                    c = F.encodeState(r.state),
                    a = {
                      url: n.authorization_endpoint,
                      code_challenge: u,
                      nonce: s,
                      state: c,
                      client_id: r.clientID,
                      client_secret: r.clientSecret,
                      client_auth_method: r.clientAuthMethod,
                      login_hint: e,
                      max_age: r.maxAge,
                      prompt: r.prompt,
                      resource: r.resource,
                      redirect_uri: r.redirectUri,
                      response_mode: r.responseMode,
                      scope: r.scope,
                      code_challenge_method: "S256",
                      response_type: "code"
                    };
                  return Promise.resolve(t._clientStore.setAuthorizeRequest(a)).then(function () {
                    return Promise.resolve(t._clientStore.setVerifier(u, i)).then(function () {
                      return a;
                    });
                  });
                });
              });
            });
          } catch (e) {
            return Promise.reject(e);
          }
        };
      }, n.buildAuthorizeRequest = function (e) {
        try {
          var t = this,
            r = t._createAuthorizeRequestBuilder(e);
          if (e.username) return Promise.resolve(r(e.username));
          var n = t.ui,
            o = n.open;
          return Promise.resolve(t.cacheOptions.getDefaultUsername()).then(function (e) {
            return o.call(n, {
              closeOnFinish: !1,
              defaultValue: e,
              submit: r
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.loginWithPopup = function (e, t) {
        void 0 === e && (e = {});
        try {
          var r = this;
          return Promise.resolve(function (n, o) {
            try {
              var i = (e.responseMode = "fragment", Promise.resolve(r.buildAuthorizeRequest(e)).then(function (e) {
                return Promise.resolve(r.api.authorizeWithPopup(e, t)).then(function (t) {
                  return Promise.resolve(r.verifyAuthorizeResponse(e, t));
                });
              }));
            } catch (e) {
              return o(!0, e);
            }
            return i && i.then ? i.then(o.bind(null, !1), o.bind(null, !0)) : o(!1, i);
          }(0, function (e, t) {
            if (r.ui.close(), e) throw t;
            return t;
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.login = function (e) {
        void 0 === e && (e = {});
        try {
          var t = this;
          return Promise.resolve(t.buildAuthorizeRequest(e)).then(function (r) {
            function n() {
              t.window.location.href = o;
            }
            var o = t.api.buildAuthorizeUrl(r),
              i = function () {
                if ("function" == typeof e.beforeRedirect) return Promise.resolve(e.beforeRedirect(o)).then(function () {});
              }();
            return i && i.then ? i.then(n) : n();
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.loginCallback = function (e) {
        try {
          var t,
            r = this,
            n = null != (t = null == e ? void 0 : e.url) ? t : r.window.location.href;
          return Promise.resolve(r._clientStore.getAuthorizeRequest()).then(function (e) {
            var t;
            if ("fragment" === e.response_mode) t = r.api.parseAuthorizeResponseFromFragment(n);else {
              if ("query" !== e.response_mode) throw new Error("Unsupported response_mode");
              t = r.api.parseAuthorizeResponseFromQuery(n);
            }
            return Promise.resolve(r.verifyAuthorizeResponse(e, t)).then(function (t) {
              return {
                authorization: t,
                state: F.decodeState(e.state)
              };
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.verifyAuthorizeResponse = function (e, t) {
        try {
          var r = this;
          if (e.state !== t.state) throw new Error("states don't match");
          return Promise.resolve(r.getOpenIdConfiguration(e.login_hint)).then(function (n) {
            var o = t.code,
              i = e.client_auth_method,
              u = e.client_secret,
              s = e.client_id,
              c = n.token_endpoint;
            return Promise.resolve(r._clientStore.getVerifier(e.code_challenge)).then(function (t) {
              return Promise.resolve(r.api.getTokenWithAuthorizationCode({
                url: c,
                client_id: s,
                client_secret: u,
                client_auth_method: i,
                grant_type: "authorization_code",
                code: o,
                code_verifier: t,
                redirect_uri: e.redirect_uri
              })).then(function (t) {
                return Promise.resolve(x.verifyIdToken(x.createRemoteJWKGetter(n.jwks_uri), t.id_token, e.nonce)).then(function (n) {
                  var o = {
                    accessToken: t.access_token,
                    expiresAt: Date.now() + 1e3 * t.expires_in,
                    idToken: n,
                    scope: C(e.scope),
                    resource: e.resource
                  };
                  return Promise.resolve(r._clientStore.setAuthorization(o)).then(function () {
                    return o;
                  });
                });
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.getOpenIdConfiguration = function (e) {
        try {
          var t,
            r = this,
            n = function n(_n) {
              return t ? _n : Promise.resolve(r.issuerResolver.resolve(e, r.fallbackIssuer)).then(function (t) {
                return Promise.resolve(r._clientStore.setOpenIdConfiguration(e, t, "number" == typeof r.cacheOptions.issuer ? r.cacheOptions.issuer : 36e5)).then(function () {
                  return t;
                });
              });
            },
            o = function () {
              if (r.cacheOptions.issuer) return Promise.resolve(r._clientStore.getOpenIdConfiguration(e)).then(function (e) {
                if (e) return t = 1, e;
              });
            }();
          return Promise.resolve(o && o.then ? o.then(n) : n(o));
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.authorization = function (e) {
        void 0 === e && (e = {});
        try {
          return Promise.resolve(this._clientStore.getAuthorization(e));
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.user = function (e) {
        void 0 === e && (e = {});
        try {
          var t,
            r = this,
            n = null != (t = e.claims) ? t : ["name", "given_name", "family_name", "middle_name", "nickname", "preferred_username", "profile", "picture", "website", "email", "email_verified", "gender", "birthdate", "zoneinfo", "locale", "phone_number", "phone_number_verified", "address", "updated_at", "wallet_address", "wallet_type_hint"];
          return Promise.resolve(r.authorization(e)).then(function (e) {
            var t = {
              sub: e.idToken.sub
            };
            if (r.cacheOptions.userinfo) {
              for (var o, i = w(n); !(o = i()).done;) {
                var u = o.value;
                e.idToken[u] && (t[u] = e.idToken[u]);
              }
              return t;
            }
            return Promise.resolve(r.getOpenIdConfiguration(e.idToken.sub)).then(function (o) {
              return Promise.resolve(r.api.userinfo({
                client_id: r.fallbackLoginOptions.clientID,
                client_secret: r.fallbackLoginOptions.clientSecret,
                client_auth_method: r.fallbackLoginOptions.clientAuthMethod,
                access_token: e.accessToken,
                url: o.userinfo_endpoint
              })).then(function (e) {
                for (var r, o = w(n); !(r = o()).done;) {
                  var i = r.value;
                  e[i] && (t[i] = e[i]);
                }
                return t;
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.buildLogoutRequest = function (e) {
        try {
          var t = this;
          return Promise.resolve(t.authorization(e)).then(function (r) {
            return Promise.resolve(t.getOpenIdConfiguration(r.idToken.sub)).then(function (n) {
              var o;
              if (null == n.end_session_endpoint) throw new Error("end_session_endpoint must exist");
              var i = null != (o = e.postLogoutRedirectUri) ? o : t.fallbackLogoutOptions.postLogoutRedirectUri;
              if (null == i) throw new Error("postLogoutRedirectUri must be supplied");
              var u = {
                client_id: t.fallbackLoginOptions.clientID,
                client_secret: t.fallbackLoginOptions.clientSecret,
                client_auth_method: t.fallbackLoginOptions.clientAuthMethod,
                url: n.end_session_endpoint,
                id_token_hint: r.idToken.__raw,
                post_logout_redirect_uri: i,
                state: F.encodeState(e.state)
              };
              return Promise.resolve(t._clientStore.setLogoutRequest(u)).then(function () {
                return u;
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.logout = function (e) {
        var t = void 0 === e ? {} : e,
          r = t.clientID,
          n = t.username,
          o = t.scope,
          i = t.resource,
          u = v(t, H);
        try {
          var s,
            c = this,
            l = function l(e) {
              return s ? e : Promise.resolve(c.buildLogoutRequest(f)).then(function (e) {
                function t() {
                  return Promise.resolve(c._clientStore.deleteAuthorization(h)).then(function () {
                    c.window.location.href = r;
                  });
                }
                var r = c.api.buildLogoutUrl(e),
                  n = function () {
                    if ("function" == typeof f.beforeRedirect) return Promise.resolve(f.beforeRedirect(r)).then(function () {});
                  }();
                return n && n.then ? n.then(t) : t();
              });
            },
            f = a({}, c.fallbackLogoutOptions, u),
            h = {
              clientID: r,
              username: n,
              scope: o,
              resource: i
            },
            d = function () {
              if (!f.rpInitiatedLogout) return Promise.resolve(c._clientStore.deleteAuthorization(h)).then(function () {
                s = 1;
              });
            }();
          return Promise.resolve(d && d.then ? d.then(l) : l(d));
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.logoutCallback = function (e) {
        void 0 === e && (e = {});
        try {
          var t,
            r,
            n = this,
            o = null != (t = null == (r = e) ? void 0 : r.url) ? t : n.window.location.href;
          return Promise.resolve(n._clientStore.getLogoutRequest()).then(function (e) {
            var t = n.api.parseAuthorizeResponseFromQuery(o);
            return Promise.resolve(n.verifyLogoutResponse(e, t)).then(function () {
              return F.decodeState(e.state);
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }, n.verifyLogoutResponse = function (e, t) {
        try {
          if (e.state !== t.state) throw new Error("states don't match");
          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }, t;
    }();
  return G;
});